var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.uiLock)?_c('p',[_vm._v(" "+_vm._s(_vm.$t('data_import.next_import_possible'))+" "+_vm._s(_vm.minutes)+":"+_vm._s(_vm.seconds)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }